export default "__VITE_ASSET__CplnsR76__"